export const AboutContent = () => {
	return (
		<div className="flex flex-col gap-4 text-[14px] md:text-[15px] text-[#666] dark:text-[#666] font-lato leading-7 md:leading-8">
			<p>
				Back in{" "}
				<span className="font-semibold text-black dark:text-[#B8B8B8]">
					2020
				</span>
				, I started learning web development just HTML, CSS, and JavaScript in a
				browser tab. That spark turned into something serious pretty quickly. 🚀
			</p>

			<p>
				I spent my early years building landing pages and WordPress sites for
				local businesses, while completing projects for my web programming
				courses at university. That's where I picked up{" "}
				<span className="font-semibold text-black dark:text-[#B8B8B8]">
					Node.js
				</span>{" "}
				and{" "}
				<span className="font-semibold text-black dark:text-[#B8B8B8]">
					PHP
				</span>{" "}
				— and got comfortable shipping real products under deadlines.
			</p>

			<p>
				Today I work as a{" "}
				<span className="font-semibold text-black dark:text-[#B8B8B8]">
					professional frontend developer
				</span>
				, with a strong lean toward fullstack when the project calls for it. I
				care deeply about the intersection of good design and clean,
				maintainable code. My stack of choice is{" "}
				<span className="font-semibold text-black dark:text-[#B8B8B8]">
					React
				</span>{" "}
				and{" "}
				<span className="font-semibold text-black dark:text-[#B8B8B8]">
					Next.js
				</span>
				, with TypeScript keeping things honest.
			</p>

			<p>
				Outside of client work, I enjoy building side projects — experimenting
				with databases, auth systems, and whatever new tool has caught my
				attention. I think the best developers never stop being curious. 📚
			</p>
		</div>
	);
};
